import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            mx: 'auto',
            width: '100%',
        },
        container: {
            width: '100%',
            justifyContent: {base: 'center', xl: 'flex-start'},
            alignItems: {base: 'center', xl: 'flex-start'},
            px: {base: remCalc(16), md: remCalc(24), lg: 0},
        },
        imageContainer: {
            w: '100%',
            maxW: {base: '100%', md: remCalc(598), lg: remCalc(810), xl: remCalc(1067)},
            mb: {base: remCalc(24), xl: 0},
        },
        image: {
            width: '100%',
        },
        productsContainer: {
            maxW: {base: '100%', xl: remCalc(508)},
            mx: 'auto',
            alignSelf: 'stretch',
            px: {xl: remCalc(24)},
        },
        textblockContainer: {
            gap: remCalc(16),
            mb: remCalc(16),
            textAlign: 'center',
        },
        label: {
            textTransform: 'uppercase',
            color: 'text.secondary',
        },
        slider: {
            maxW: {base: '100%', md: remCalc(315), lg: remCalc(422), xl: '100%'},
            mx: {base: 'auto', xl: 0},
            height: {xl: '100%'},

            '.stp-swiper': {
                height: {xl: '100%'},
            },
        },
        tile: {
            alignItems: 'center',
            textAlign: 'center',
            height: {xl: '100%'},
            justifyContent: 'flex-start',
            gap: remCalc(8),
        },
        tileElem: {
            alignItems: 'center',
        },
        productImage: {
            maxW: {base: remCalc(226), md: remCalc(230), lg: remCalc(310), xl: remCalc(332)},
            h: 'auto',
            display: 'inline',
            mb: remCalc(16),
        },
        productId: {
            textTransform: 'uppercase',
            color: 'text.secondary',
            mb: remCalc(4),
        },
        omnibusPrice: {
            color: 'text.secondary',
        },
        omnibusPercentage: {
            color: 'text.secondary',
            ml: remCalc(4),
        },
        chevronIcon: {
            width: {base: remCalc(24), md: remCalc(32), xl: remCalc(40)},
            height: {base: remCalc(24), md: remCalc(32), xl: remCalc(40)},
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'border.dark',
            borderRadius: '50%',
            cursor: 'pointer',
            zIndex: 2,
            position: 'absolute',
            top: {base: remCalc(113), lg: remCalc(150), xl: remCalc(166)},
            transform: 'translateY(-50%)',
        },
    },
}
